export type CategoryIDList = string[];

export const FASHION_CHILDREN_2_PLUS_CATEGORY_IDS: CategoryIDList = [
  "600001343",
  "600001345",
  "90000410022",
];

export const FASHION_BRAS_CATEGORY_IDS: CategoryIDList = ["8000016892"];

export const FASHION_CHILDRENSWEAR_CATEGORY_IDS: CategoryIDList = [
  "6000030",
  "6000034",
  "6000150170",
];

export const FASHION_DEFAULT_CATEGORY_IDS: CategoryIDList = [
  "50000298",
  "50000300",
];

export const ELECTRICALS_DEFAULT_CATEGORY_IDS: CategoryIDList = [
  "6000052",
  "6000047",
  "600002446",
  "8000013309",
  "80000462",
  "80000463",
  "600002591",
  "80000973",
  "800009348",
  "80000398",
  "9600620006",
  "800004408",
  "8000021438",
  "7000430163",
];

export const BEAUTY_DEFAULT_CATEGORY_IDS: CategoryIDList = ["50000296"];

export const MADE_TO_MEASURE_CATEGORY_IDS: CategoryIDList = ["5000070286"];
